module.exports = __webpack_public_path__ + "img/collection-memoireRingsPlatinum.28dad93.jpg";